import { render } from "./HomePortfolio.vue?vue&type=template&id=34d23740"
import script from "./HomePortfolio.vue?vue&type=script&lang=js"
export * from "./HomePortfolio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__